
  import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
  import {ICarUnion} from "@/modules/CarList/interfaces/car-union.interface";
  import _ from 'lodash';
  import CarsUnionCell from "@/modules/CarList/components/carsUnion/CarsUnionCell.vue";

  @Component({
    components: {
      CarsUnionCell,
    }
  })
  export default class CarsUnionRow extends Vue {
    @Prop() carUnion: ICarUnion.IEntity;
    @Prop() index: number;
    @Prop() cells: ICarUnion.ITableCell[];
    @Prop() active: boolean;

    $refs: any;
    publicPath = process.env.VUE_APP_PUBLIC_URL;
    propType = ICarUnion.PropType;
    defaultForm = {
      corpId: null,
      corpName: '',
      car1NumberOld: '',
      car1Number: '',
      car2NumberOld: '',
      car2Number: '',
      car3NumberOld: '',
      car3Number: '',
      car4NumberOld: '',
      car4Number: '',
      personId: null,
      personName: '',
      phone: '',
      login: '',
      email: '',
      comment: '',
      parks: [],
    };
    formModel: any = {};
    startModel: any = {};
    clickedCell = null;
    errorProps = [];
    hasChanges = false;
    dontClearData = false;

    prepareData() {
      this.formModel = {...this.defaultForm};
      this.startModel = {...this.defaultForm};

      let values = {
        car1NumberOld: this.carUnion.car1Number,
        car2NumberOld: this.carUnion.car2Number,
        car3NumberOld: this.carUnion.car3Number,
        car4NumberOld: this.carUnion.car4Number,
        parks: this.carUnion.parks ? this.carUnion.parks : [],
      };
      Object.keys(this.defaultForm).forEach(prop => {
        let formNames = ['formModel', 'startModel'];
        formNames.forEach(formName => {
          if (values[prop])
            Vue.set(this[formName], prop, values[prop]);
          else
            Vue.set(this[formName], prop, this.carUnion[prop]);
        });
      });
    }

    async saveData() {
      let success = true;
      this.validateForm();

      if (this.hasChanges && !this.errorProps.length) {
        let formToSend = {
          ...this.formModel,
          car1NumberNew: this.formModel.car1Number,
          car1NumberOld: this.startModel.car1Number,
          car2NumberNew: this.formModel.car2Number,
          car2NumberOld: this.startModel.car2Number,
          car3NumberNew: this.formModel.car3Number,
          car3NumberOld: this.startModel.car3Number,
          car4NumberNew: this.formModel.car4Number,
          car4NumberOld: this.startModel.car4Number,
        };
        ['car1Number', 'car2Number', 'car3Number', 'car4Number'].forEach(prop => delete formToSend[prop]);
        success = await this.$store.dispatch('carList/saveCarsUnion', {formModel: formToSend, index: this.index});

        if (success) {
          this.hasChanges = true;
          this.$notify({
            title: 'Успешно',
            message: 'Данные успешно сохранены',
            type: 'success'
          });
        }
      }

      setTimeout(() => {
        this.$refs.carNumber.forEach(el => {
          el.updateNumber();
        });
      }, 0);

      return success;
    }

    validateForm() {
      this.hasChanges = false;
      Object.keys(this.formModel).forEach(prop => {
        let indexProp = this.errorProps.findIndex(item => item === prop);

        switch (prop) {
          case 'corpName':
            if (!this.formModel[prop] || (this.formModel[prop] && !this.formModel[prop].length)) {
              if (indexProp < 0) this.errorProps.push(prop);
            }
            else {
              if (this.formModel[prop] !== this.startModel[prop]) this.hasChanges = true;
              if (indexProp >= 0) this.errorProps.splice(indexProp, 1);
            }
            break;

          case 'car1Number':
          case 'car2Number':
          case 'car3Number':
          case 'car4Number':
            if (this.formModel[prop] && this.formModel[prop].length && (this.formModel[prop].length < 7 || this.formModel[prop].length > 9)) {
              if (indexProp < 0) this.errorProps.push(prop);
            }
            else {
              if (this.formModel[prop] !== this.startModel[prop]) this.hasChanges = true;

              if (indexProp >= 0) this.errorProps.splice(indexProp, 1);
            }
            break;

          case 'parks':
            if(!_.isEqual(this.formModel.parks, this.startModel.parks)) this.hasChanges = true;
            break;

          default:
            if (this.formModel[prop] !== this.startModel[prop]) this.hasChanges = true;
            break;
        }
      });
    }

    activateRow() {
      this.$emit('activateRow', this.index);
    }

    clickOnCell(cell: ICarUnion.ITableCell) {
      this.clickedCell = cell;
    }

    revertChanges() {
      this.clearData(true);
      this.$emit('activateRow', null);
    }

    async applyChanges() {
      this.validateForm();
      if (!this.errorProps.length) {
        this.$emit('activateRow', null);
      }
    }

    clearData(revert = false) {
      if (revert) {
        this.formModel = {...this.startModel};
      }
      else {
        this.formModel = {...this.defaultForm};
        this.startModel = {...this.defaultForm};
      }
      this.clickedCell = null;
      this.errorProps = [];
      this.hasChanges = false;
    }

    @Watch('active')
    async onActiveChange() {
      if (this.active && !this.errorProps.length) {
        if (!this.dontClearData) {
          this.prepareData();
        }
      }
      else {
        let success = await this.saveData();

        if (success) {
          this.dontClearData = false;
          if (!this.hasChanges && !this.formModel.corpId) {
            this.revertChanges();
            this.$store.commit('carList/clearNewCarUnion');
          }
          else {
            if (this.errorProps.length) {
              this.activateRow();
            }
            else {
              this.clearData();
            }
          }
        }
        else {
          this.dontClearData = true;
          this.activateRow();
        }
      }
    }
  }
